// api client
import { client } from '../api/client'

// types
import { PersonalData, updatedpersonalData } from '../types/personalTypes'

/**
 * Personal get data
 *
 * @returns Promise<PersonalData>
 */
const fetchData = (id: number): Promise<PersonalData> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(`/OnBoarding/${id}/Personal`)

      if (response.status === 200) {
        const personalData: PersonalData = {
          essUserOnBoardingKey: response.data.essUserOnBoardingKey,
          firstName: response.data.firstName,
          middleInitial: response.data.middleInitial,
          lastName: response.data.lastName,
          employeeEmailAddress: response.data.employeeEmailAddress,
          ssn:response.data.ssn,
          ssnLastFour: response.data.ssnLastFour,
          addressLine1: response.data.addressLine1,
          addressLine2: response.data.addressLine2,
          stateValue: response.data.stateValue,
          zip: response.data.zip,
          city: response.data.city,
          dateOfBirth: response.data.dateOfBirth,
          genderValue: response.data.genderValue,
          maritalStatusValue: response.data.maritalStatusValue,
          mainPhoneNumber: response.data.mainPhoneNumber,
          secondaryPhoneNumber: response.data.secondaryPhoneNumber,
          emergencyContactName: response.data.emergencyContactName,
          emergencyPhoneNumber: response.data.emergencyPhoneNumber,
          emergencyRelationshipValue: response.data.emergencyRelationshipValue,
          alternateEmergencyContactName:
            response.data.alternateEmergencyContactName,
          alternateEmergencyPhoneNumber:
            response.data.alternateEmergencyPhoneNumber,
          alternateEmergencyRelationshipValue:
            response.data.alternateEmergencyRelationshipValue,
          statusDescription: response.data.statusDescription,
          entityId:response.data.entityId,
          corpEntityId:response.data.corpEntityId,
          storeEntityId:response.data.storeEntityId,
          isEmergencyContactMandatory:response.data.isEmergencyContactMandatory,
          axonifyUserID:response.data.axonifyUserID,
          employeeDiscount:response.data.employeeDiscount,
          essUserKey:response.data.essUserKey,
          hasCanary:response.data.hasCanary

        }

        resolve(personalData)
      } else {
        reject({ message: 'Could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * Personal update data
 *
 * @returns Promise<PersonalData>
 */
const updateData = (id: number, data: PersonalData): Promise<PersonalData> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.patch(`/OnBoarding/${id}/Personal`, data)

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not fetch data' })
      }
      return null
    } catch (error) {
      reject(error)
    }
  })
}



const updatepersonalinformation = (data): Promise<PersonalData> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`/OnBoarding/PostPersonalInformation`, data)

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not post data' })
      }
      return null
    } catch (error) {
      reject(error)
    }
  })
}

const getUpdatedData=(essuserkey:number):Promise<updatedpersonalData>=>{
  return new Promise(async(resolve,reject)=>{
    try{
      const response=await client.get(`/OnBoarding/GetPersonalInformation?EssUserKey=${essuserkey}`)
      if(response.status===200){
        resolve(response.data)
      }else{
        reject({message:"Could not fetch data"})
      }
    }catch(error){
      reject(error)
    }
  })
}
const getDisablekeys=(entityid:number):Promise<any>=>{
  return new Promise(async(resolve,reject)=>{
    try{
      const response=await client.get(`/OnBoarding/GetPersonalInfoUpdateFields?entityId=${entityid}`)
      if(response.status===200){
        resolve(response.data)
      }else{
        reject({message:"Could not fetch data"})
      }
    }catch(error){
      reject(error)
    }
  })
}


export const personalService = {
  fetchData,
  updateData,
  updatepersonalinformation,
  getUpdatedData,
  getDisablekeys
}
